import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userId: "",
  firstName: "",
  lastName: "",
  email: "",
  role: "",
  avatar: "",
  bio: "",
  publicationsCount: 0,
  createdAt: "",
  phoneNumber: "",
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.firstName = action.payload?.firstName;
      state.lastName = action.payload?.lastName;
      state.email = action.payload?.email;
      state.role = action.payload?.role;
      state.userId = action.payload?.userId;
      state.avatar = action.payload?.avatar?.url;
      state.publicationsCount = action.payload?.publicationsCount;
      state.createdAt = action.payload?.createdAt;
      state.bio = action.payload?.bio;
      state.phoneNumber = action.payload?.phoneNumber;
    },
    clearUser: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export const { setUser, clearUser } = userSlice.actions;
export const selectUser = (state) => state.user;
export default userSlice.reducer;
